import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRIMARY_CTA } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
const easeOut = [0.23, 1, 0.32, 1] as const;
const heroReassurance = ['Immediate Digital Access', 'One-Time Payment', '7-Day Guarantee'];
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-white" data-id="element-151" data-mp="12862k3i3uktp">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-152" data-mp="xbfmhg6avp8a">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOut
      }} className="w-full" data-id="element-153" data-mp="sart4nulmwaw">
          <div className="inline-block px-3 py-1 rounded-full border border-[#C9A24B] bg-[#1F4D3A] text-white font-bold text-[10px] sm:text-sm tracking-widest mb-4 sm:mb-6" data-id="element-154" data-mp="3d21ty23jwspu">
            BARTENDING &amp; MIXOLOGY INSTRUCTOR <span className="text-[#E0C27A]" data-id="element-155" data-mp="3j9ka79gurdf2">ATLAS</span>
          </div>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight leading-tight mb-4 sm:mb-6 text-[#1F4D3A] uppercase" data-id="element-156" data-mp="3o7bzdvq44lfk">
            Solve <span className="text-[#9C7726]" data-id="element-157" data-mp="39a38f34q1jod">Months of Bartending Class Planning</span>{' '}
            <span className="bg-[#1F4D3A] text-white px-2 box-decoration-clone" data-id="element-158" data-mp="3e7uzjuxjl1ri">in Just 5 Minutes!</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: easeOut
      }} className="relative w-full max-w-[360px] sm:max-w-xl md:max-w-2xl mb-4 sm:mb-6" data-id="element-159" data-mp="358hleoyh3p0g">
          <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="relative z-10 w-full h-auto drop-shadow-xl" data-id="element-160" data-mp="2vglm5aknhsun" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: easeOut
      }} className="w-full" data-id="element-161" data-mp="2ljz38rbvxbv9">
          <p className="text-sm sm:text-lg md:text-xl text-slate-700 leading-snug max-w-3xl mx-auto mb-1 sm:mb-2" data-id="element-162" data-mp="n98cdkmjmzmb">
            The Complete{' '}
            <span className="font-semibold text-[#84651F]" data-id="element-163" data-mp="ddwwgyzefmcz">
              6-IN-1 Visual Bartending, Mixology &amp; Professional Bar Training System for Bartending Instructors, Bar Trainers &amp; Mixology Educators.
            </span>
          </p>
          <p className="text-sm sm:text-lg md:text-xl text-slate-700 leading-snug max-w-3xl mx-auto mb-3 sm:mb-4" data-id="element-164" data-mp="162m47guympxp">
            <span className="font-semibold text-[#1F4D3A]" data-id="element-165" data-mp="114kkqutmgolp">6 Professional Visual Training Volumes</span> + 5
            Exclusive Bonuses — everything organized to help you plan, explain, train and assess every
            bartending class, from bar tools and classic cocktails to advanced mixology, spirits, garnishing and bar operations, from beginner to advanced, with more clarity, structure and confidence.
          </p>

          <p className="text-xs sm:text-sm font-bold tracking-widest text-[#84651F] mb-5 sm:mb-7" data-id="element-166" data-mp="21aeidfnb4ja3">
            FROM BAR TOOLS &amp; CLASSIC COCKTAILS TO MIXOLOGY, SPIRITS, OPERATIONS &amp; TEACHING METHODS
          </p>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-167" data-mp="2b1r9u65717fl">
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10" data-id="element-168" data-mp="2fzstas6j78rl">
              {PRIMARY_CTA}
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-slate-700/80 mb-3" data-id="element-169" data-mp="2p10ec8k1ed3q">
            {heroReassurance.map(item => <div key={item} className="flex items-center gap-1.5" data-id="element-170" data-mp="un98lk4twddk">
                <CheckCircle size={14} className="text-[#9C7726]" data-id="element-171" data-mp="zlkjly6v0txd" />
                <span className="font-medium" data-id="element-172" data-mp="zlswvr6wa193">{item}</span>
              </div>)}
          </div>

          <p className="text-xs text-slate-500" data-id="element-173" data-mp="4dgy4w0stp8n">
            6 VISUAL VOLUMES · 300 TRAINING PAGES · 5 EXCLUSIVE BONUSES
          </p>
        </motion.div>
      </div>
    </section>;
}